import { MutableRefObject,useRef } from 'react';
import { useSelector } from 'react-redux';

import useResizeObserver from '~/hooks/useResizeObserver';
import { getWindowWidth } from '~/store/reducers/app/selectors';

type Params = {
  margin?: number;
};

type Return = {
  isElementFitInWidthScreen: boolean;
  elementRef: MutableRefObject<HTMLDivElement | null>;
};

export default function useIsElementFitInScreenWidth(params?: Params): Return {
  const { margin = 0 } = params ?? {};
  const windowWidth = useSelector(getWindowWidth);

  const elementRef = useRef<HTMLDivElement | null>(null);
  const { width } = useResizeObserver({ ref: elementRef });

  return {
    isElementFitInWidthScreen: windowWidth > width + margin,
    elementRef,
  };
}
